import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

import { useUtils } from '@core/libs/i18n'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useHelpers from '@/views/modules/useHelpers'

export default function useGeofenceList() {
  // Use toast
  const toast = useToast()

  const { t } = useUtils()

  const refGeofenceListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'id',  label: '#'},
    { key: 'name', sortable: false, label: t('Name')},
    { key: 'owner', sortable: true, label: t('Owner Name')},
    { key: 'group', sortable: true, label: t('Group Name')},
    { key: 'contract', sortable: true, label: t('contract name')},
    { key: 'category', sortable: true, label: t('Category')},
    { key: 'actions' ,label:t('actions')},
  ]

  const perPage = ref(25)
  const totalGeofence = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('created_at')
  const isSortDirDesc = ref(true)
  const ownersFilter = ref([])
  const groupFilter = ref(null)
  const contractsFilter = ref([])
  const typeFilter = ref(null)
  const categoriesFilter = ref([])


  const geofences = ref([])

  const requestStatus = ref(false)


  const filterOptions = ref({})

  const dataMeta = computed(() => {
    const localItemsCount = refGeofenceListTable.value ? refGeofenceListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalGeofence.value,
    }
  })

  const refetchData = () => {
    refGeofenceListTable.value.refresh()
  }

  const filter = ref({})

  watch([currentPage, perPage, searchQuery, ownersFilter, groupFilter, categoriesFilter, contractsFilter, typeFilter ], () => {

    filter.value = {
      ...(ownersFilter.value && {owners: ownersFilter.value}),
      ...(groupFilter.value && {group: groupFilter.value}),
      ...(contractsFilter.value && {contracts: contractsFilter.value}),
      ...(typeFilter.value && {type: typeFilter.value}),
      ...(categoriesFilter.value && {categories: categoriesFilter.value}),
      ...(searchQuery.value && {q: searchQuery.value})
    }

    refetchData()
  })


  //filters/getFilterBy

  // get filters for index
  // store.dispatch('app-geofence/getGeofenceFilters')
  //   .then(res => filterOptions.value = res.data).catch(reason => {})


  const fetchGeofence = (ctx, callback) => {

    requestStatus.value = true

    store
      .dispatch('app-geofence/fetchGeofences', {
        length: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortedDesc: isSortDirDesc.value,
        ...filter.value
      })
      .then(response => {
        requestStatus.value = false
        const { data } = response.data.geofences
        const { total } = response.data.geofences.meta

        callback(data)
        geofences.value = data
        totalGeofence.value = total
      })
      .catch(() => {
        requestStatus.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error fetching geofence list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }


  const deleteRow = (id, callback,reject) => {
    requestStatus.value = true
    store.dispatch('app-geofence/deleteGeofence', id)
      .then(r => {
        requestStatus.value = false
        callback()
      })
      .catch(e => {
        
        requestStatus.value = false
        reject()
      })
  }


  return {

    fetchGeofence,
    deleteRow,

    tableColumns,
    perPage,
    currentPage,
    totalGeofence,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refGeofenceListTable,
    ownersFilter,
    categoriesFilter,
    groupFilter,
    contractsFilter,
    typeFilter,
    filterOptions,

    requestStatus,
    refetchData,
    geofences

  }
}
